var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    id: "svg822",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-289.0625)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.71555553
    },
    id: "rect992",
    width: 4,
    height: 24,
    x: 3,
    y: 292.0625,
    rx: 2,
    ry: 1.9999999
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 1.9999999,
    rx: 2,
    y: 292.0625,
    x: 9,
    height: 24,
    width: 4,
    id: "rect994",
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.71555553
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.71555553
    },
    id: "rect996",
    width: 4,
    height: 24,
    x: -86.261955,
    y: 280.90771,
    rx: 2,
    ry: 1.9999999,
    transform: "rotate(-20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.fa81ac3f1725511ebae7e4a73f538efc.svg";
export { ForwardRef as ReactComponent };